import { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useContext } from "react";
export const DeviceMineContext = createContext();

function DeviceMineProvider(props) {
  const [deviceMine, setDeviceMine] = useState();
  const token = Cookies.get("token");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  var myHeaders = new Headers();
  myHeaders.append("Authorization", token);

  var formdata = new FormData();

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  useEffect(() => {
    fetch("https://assessn.mmaviot.com/api/device_mine", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setDeviceMine(result.data);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: "خطایی رخ داده است.",
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);
  return (
    <DeviceMineContext.Provider value={{ deviceMine, setDeviceMine }}>
      {props.children}
    </DeviceMineContext.Provider>
  );
}
export { DeviceMineProvider };
